import { useEffect } from "react";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { getRatingStar } from "./helper";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { ExternalDoctorAction } from "../../../redux/actions/HomeAction";
import { callHomePageAPI } from "../CommonComponent/commonfunctionality";
import { getProviderPortalId } from "../../../Utils/types";

const HomePage = () => {
  const dispatch = useDispatch();
  const feedbackPerRow = 4;
  const [next, setNext] = useState(feedbackPerRow);
  const [externalDoctorUrl, setExternalDoctorUrl] = useState("");

  useEffect(() => {
    callHomePageAPI(dispatch);
  }, []);

  const getHomePageDetails = useSelector(
    (state) => state.homeReducer.getHomePageDetails
  );
  const providerDetails = getHomePageDetails?.providerDetail?.[0];

  const handleMoreFeedback = () => {
    setNext(next + feedbackPerRow);
  };
  const ExternalDoctorHandler = async () => {
    const temp = {
      loginMobileNo: providerDetails?.mobileNo1,
      providerId: +getProviderPortalId(),
    };
    let res = dispatch(ExternalDoctorAction(temp));
    res.then((res) => {
      setExternalDoctorUrl(res?.data?.data);
      setTimeout(() => {
        document.getElementById("externalDoctor").click();
      }, 500);
    });
  };
  return (
    <div className="right-section">
      {/* <!-- Hospital details Section  --> */}
      <div className="hospital-details-section">
        <div className="row g-0">
          <div className="col-lg-5">
            <div className="card h-100 left-card">
              <div className="carousel-box" data-bs-ride="carousel">
                {getHomePageDetails?.imageDetails === null ? (
                  <img
                    style={{ width: "100%", height: "100%" }}
                    src="./images/hospitalimage.png"
                    alt="hospital-logo"
                  />
                ) : (
                  <Carousel autoPlay infiniteLoop showArrows showThumbs={false}>
                    {getHomePageDetails?.imageDetails?.map((ele, i) => {
                      return (
                        <div style={{ height: "380px" }} key={i}>
                          <img
                            alt=""
                            style={{ height: "100%" }}
                            src={ele?.imageUrl}
                          />
                        </div>
                      );
                    })}
                  </Carousel>
                )}
              </div>
            </div>
          </div>
          <div className="col-lg-7">
            <div
              className="card h-100"
              style={{ borderRadius: "0 10px 10px 0" }}
            >
              <div className="hospital-details">
                <div className="top-details d-flex justify-content-between">
                  <div className="left-image">
                    <img
                      src={
                        providerDetails?.icon
                          ? providerDetails?.icon
                          : "./images/noimageavailable.jpg"
                      }
                      alt="hospital-logo"
                    />
                  </div>
                  <div className="right-data">
                    <span className="review" style={{ display: "none" }}>
                      In Review
                    </span>
                    &nbsp;
                    <span className="profile-data" style={{ display: "none" }}>
                      Completed
                    </span>
                    <span className="location" style={{ display: "none" }}>
                      <img src="./images/DistanceLogo.png" alt="" />
                      <span>5 Kms</span>
                    </span>
                  </div>
                </div>
                <h2 className="name">{providerDetails?.providerName}</h2>
                <h3 className="address-1">
                  {providerDetails?.city}
                  {providerDetails?.city && ","} {providerDetails?.state}
                </h3>
                <p className="address-2">
                  {providerDetails?.houseNumber}
                  {providerDetails?.houseName !== "" && ","}
                  {providerDetails?.houseName}
                  {providerDetails?.address1 !== "" && ","}
                  {providerDetails?.address1}
                  {providerDetails?.address2 !== "" && ","}
                  {providerDetails?.address2}
                </p>
                <div className="contact-number">
                  <span>
                    <img src="./images/callicon.svg" alt="call Icon" />
                  </span>
                  &nbsp;
                  <span>+91- {providerDetails?.mobileNo1}</span>,&nbsp;
                  <span>+91- {providerDetails?.mobileNo2}</span>
                </div>
                <p className="time">
                  Timings: &nbsp;
                  {providerDetails?.timeSlot}
                </p>
                <div className="about-section">
                  <div className="about-card">
                    <div style={{ marginTop: "5px" }}>
                      <img
                        src="./images/appoimentIcon.svg"
                        alt="appoiment Icon"
                      />
                    </div>
                    <p>
                      {getHomePageDetails?.totalAppointmentsBadge} <br />
                      Appointments
                    </p>
                  </div>
                  {getHomePageDetails?.totalCustomerRecommendedBadge > 0 && (
                    <div className="about-card">
                      <div>
                        <img src="./images/recomemdedIcon.svg" alt="" />
                      </div>
                      <p>
                        Customer <br /> Recommended
                      </p>
                    </div>
                  )}
                  {providerDetails?.providerChainName && (
                    <div className="about-card">
                      <div style={{ marginTop: "5px" }}>
                        <img
                          src="./images/franchise.png"
                          style={{ widht: "30px", height: "25px" }}
                          alt=""
                        />
                      </div>
                      <p>{providerDetails?.providerChainName}</p>
                    </div>
                  )}
                  <div className="about-card">
                    <div style={{ marginTop: "5px" }}>
                      <img src="./images/panIndiaIcon.svg" alt="" />
                    </div>
                    <p>
                      {getHomePageDetails?.totalNoOfBranches} Branches
                      <br />
                      Pan India
                    </p>
                  </div>
                  {getHomePageDetails?.haVerified === "HA verified" && (
                    <div className="about-card">
                      <div style={{ marginTop: "5px" }}>
                        <img src="./images/registrationIcon.svg" alt="" />
                      </div>
                      <p>
                        HA
                        <br />
                        Verified
                      </p>
                    </div>
                  )}
                  {getHomePageDetails?.homeCollection !== null &&
                    getHomePageDetails?.homeCollection !== "" && (
                      <div className="about-card">
                        <div style={{ marginTop: "5px" }}>
                          <img src="./images/homeIcon.svg" alt="" />
                        </div>
                        <p>{getHomePageDetails?.homeCollection}</p>
                      </div>
                    )}
                  {getHomePageDetails?.googleReviewsRating !== null && (
                    <div className="about-card" style={{ width: "145px" }}>
                      <div style={{ marginTop: "5px" }}>
                        <img src="./images/google.png" alt="" />
                      </div>
                      <div>
                        <p>Google Rating</p>
                        <div style={{ marginLeft: "6px", display: "flex" }}>
                          {getRatingStar(
                            getHomePageDetails?.googleReviewsRating
                          )}
                        </div>
                      </div>
                    </div>
                  )}
                  {getHomePageDetails?.googleReviewsCount !== null && (
                    <div className="about-card">
                      <div style={{ marginTop: "5px" }}>
                        <img
                          style={{ height: "24px" }}
                          src="./images/google.png"
                          alt=""
                        />
                      </div>
                      <div>
                        <p>Google Review</p>
                        <div>
                          <p className="review-count">
                            {getHomePageDetails?.googleReviewsCount}
                          </p>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <!-- Service Section  --> */}
      <div className="card service-offer-card">
        <div className="card-body">
          <h2 className="service-card-header">Services Offered</h2>
          <div className="service-offer-section">
            <a id="externalDoctor" target="_blank" href={externalDoctorUrl}></a>
            <div
              className="service-offer-item"
              style={{ cursor: "pointer" }}
              onClick={ExternalDoctorHandler}
            >
              <div className="service-icon">
                <img
                  src="https://uat.healthassure.in/Products/Images/ServiceIcons/Doctor-Visits.png"
                  style={{
                    overflow: "hidden",
                  }}
                  alt=""
                />
              </div>
              <p className="text-center">Doctor Visits</p>
            </div>
            {getHomePageDetails?.services?.map((ele, index) => {
              return (
                <div className="service-offer-item" key={index}>
                  <div className="service-icon">
                    <img
                      src={ele?.imageUrl}
                      style={{ overflow: "hidden" }}
                      alt=""
                    />
                  </div>
                  <p className="text-center">{ele?.name}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
      {/* <!-- Customer Feedback Section  --> */}
      <div className="card customer-feedback-section">
        <div className="card-body">
          <h2 className="feedback-heading">Customers Feedback</h2>
          <div className="row gx-5">
            {getHomePageDetails?.customersFeedback
              ?.slice(0, next)
              ?.map((ele, index) => {
                return (
                  <div className="col-md-6" key={index}>
                    <div className="card customer-feedback-card">
                      <div className="card-body">
                        <div className="customer-details d-flex justify-content-between align-items-center">
                          <div className="d-flex align-items-center">
                            <div>
                              <img src="./images/customerimg.png" alt="" />
                            </div>
                            <p className="customer-name mb-0">{ele?.name}</p>
                          </div>
                          <div>{getRatingStar(ele?.rating)}</div>
                        </div>
                        <p className="feedback-text">{ele?.remarks}</p>
                      </div>
                    </div>
                  </div>
                );
              })}
            {next < getHomePageDetails?.customersFeedback?.length && (
              <div className="viewMore-btn">
                <button
                  className="btn"
                  type="button"
                  onClick={handleMoreFeedback}
                >
                  View More
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomePage;
